import React, { useState } from 'react';
import styled from 'styled-components';
import { FilterType } from '../FilterData';
import {
  Bottom,
  ButtonBox,
  CancleButton,
  ApplyButton,
} from './OptionModal.styles';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function TypeOption({ onClose, filters, setFilters }: Props) {
  const [selectType, setSelectType] = useState(filters.type);

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    setFilters({
      ...filters,
      type: selectType,
    });
    onClose();
  };
  return (
    <Wrapper>
      <OptionBox>
        경매/공매
        <TabList>
          <Tab isActive={selectType === 'a'} onClick={() => setSelectType('a')}>
            경매
          </Tab>
          <Tab isActive={selectType === 'p'} onClick={() => setSelectType('p')}>
            공매
          </Tab>
        </TabList>
      </OptionBox>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>저장</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default TypeOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OptionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const TabList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const Tab = styled.div<{ isActive: boolean }>`
  width: 100%;
  text-align: center;
  padding: 8px 16px;
  border-radius: 8px;
  border-width: 1px;
  border: ${({ isActive }) => `1px solid ${isActive ? '#008AFF' : '#989BA2'}`};

  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${({ isActive }) => (isActive ? '#008AFF' : '#989BA2')};
`;
